module.exports = __webpack_public_path__ + "img/grass.3d7aa37d.jpg";